import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';

export default class CreateTeamForm {
  public managerId: string = '';

  public rules: { [key: string]: FormValidationFunction[] } = {
    managerId: [
      (v: string) => !!v || 'You have to select user',
    ],
  };
}
